import { useMutation } from "@tanstack/react-query"
import { sendFeedback } from "../feedback"

export const useCreateFeedback = () => {
  return useMutation({
    mutationFn: sendFeedback,
  })
}
